import {getRestaurant} from "../../api/features/restaurant";

const state = () => ({

  restaurant:{},
  newsId: null
})

const getters = {
  get_restaurant(state) {
    return state.restaurant;
  },
}

const mutations = {
  SET_RESTAURANT(state,data){
    state.restaurant = data;}
}

const actions = {
  async fetchRestaurant({ commit }) {
    try {
      const response = await getRestaurant();
      commit('SET_RESTAURANT', response.data.results);
    } catch (error) {
    }
  },

}




export  default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
